import type { HTMLAttributes } from "react";
import React from "react";

export interface CKFilterGroupProps extends HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
}

export const CKFilterGroup = React.forwardRef<HTMLElement, CKFilterGroupProps>(
  (props, ref) => {
    const { as = "ul", children, ...restProps } = props;
    return React.createElement(as, { ...restProps, ref }, children);
  }
);

CKFilterGroup.displayName = "CKFilterGroup";
